import React, { createContext, useContext, useMemo } from 'react'

export type UnderlineStyleType = {
  width: number
  left: number
  transform: string
}

export type MenuState = {
  offsetY: number // height fo the navbar
  megaMenuSelect: number
  tabsActive: number
}

export type MegaMenuContextType = {
  menuState: MenuState
  setMenuState: React.Dispatch<React.SetStateAction<MenuState>>
  underlineStyle: UnderlineStyleType
  setUnderlineStyle: React.Dispatch<React.SetStateAction<UnderlineStyleType>>
}

export const MegaMenuContext = createContext<MegaMenuContextType>({
  menuState: {
    offsetY: 74,
    megaMenuSelect: 0,
    tabsActive: -1,
  },
  underlineStyle: {
    width: 0,
    left: 0,
    transform: 'scaleX(0)',
  },
  setUnderlineStyle: () => { },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setMenuState: () => { },
})

export const useMegaMenuContext = () => {
  const context = useContext(MegaMenuContext)

  if (context === undefined) {
    throw new Error(
      'useMegaMenuContext must be used within MegaMenuContextProvider',
    )
  }

  return context
}

type ContextProviderProps = {
  children: React.ReactNode
}

export const MegaMenuContextProvider: React.FC<ContextProviderProps> = ({ children }) => {
  const [menuState, setMenuState] = React.useState<MenuState>({
    offsetY: 74,
    megaMenuSelect: 0,
    tabsActive: -1,
  })
  const [underlineStyle, setUnderlineStyle] = React.useState<UnderlineStyleType>({
    width: 0,
    left: 0,
    transform: 'scaleX(0)',
  })

  const defaultMegaMenuContext: MegaMenuContextType = useMemo(() => ({
    menuState,
    setMenuState,
    underlineStyle,
    setUnderlineStyle,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [menuState, underlineStyle])

  return (
    <MegaMenuContext.Provider value={defaultMegaMenuContext}>
      {children}
    </MegaMenuContext.Provider>
  )
}